import React, { useEffect, useState } from "react";
import Menubar from "../../components/SalesManager/App";
import { useTranslation } from "react-i18next";
import Navbar from "../../components/navbar";
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Row,
  Select,
  Spin,
} from "antd";
import { http } from "../../services/http";
import dayjs from "dayjs";
import {
  formatMoney,
  handleInputChangeMoney,
  removeSpaces,
} from "../../utils/formatMoney";

const ConversionPage = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [inputType, setInputType] = React.useState("USD");
  const [outputType, setOutputType] = React.useState("UZS");
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [docRate, setDocRate] = useState(0);
  const [docRateApi, setDocRateApi] = useState(0);

  const handleSubmit = async (values) => {
    try {
      setSubmitLoading(true);
      console.log(submitLoading);
      await http.post("api/cashier/convertation", {
        from: values.type === 1 ? "USD" : "UZS",
        to: values.type === 1 ? "UZS" : "USD",
        rate: +removeSpaces(docRate),
        sum: +removeSpaces(values.input),
        docDate: dayjs(values.date).format("YYYY-MM-DD"),
      });
      form.setFieldsValue({
        input: "",
        output: "",
        docRate: "",
        date: "",
        type: "",
      });
      message.success(t("Successfully completed"));
    } catch (err) {
    } finally {
      setSubmitLoading(false);
    }
  };
  useEffect(() => {
    console.log(submitLoading);
  }, [submitLoading]);
  const handleCalculate = () => {
    const values = form.getFieldsValue();
    if (values.input && docRate) {
      if (values.type === 1) {
        form.setFieldsValue({
          output: formatMoney(
            +removeSpaces(values.input) * removeSpaces(docRate),
          ),
        });
      } else {
        form.setFieldsValue({
          output: formatMoney(
            +removeSpaces(values.input) / +removeSpaces(docRate),
          ),
        });
      }
    }
  };

  const handleChangeConversion = (value) => {
    if (value === 1) {
      setInputType("USD");
      setOutputType("UZS");
    }
    if (value === 2) {
      setInputType("UZS");
      setOutputType("USD");
    }
  };

  const getCurrencyRate = async (value) => {
    if (!value) {
      setDocRate(0);
      setDocRateApi(0);
      form.setFieldsValue({ docRate: "" });
      return;
    }
    try {
      setLoading(true);
      const { data } = await http.get(
        `api/cashier/currency-rate?Currency=UZS&Date=${dayjs(value).format(
          "YYYY-MM-DD",
        )}`,
      );
      setDocRateApi(Number(data.data));
      setDocRate(Number(data.data));
      form.setFieldsValue({ docRate: Number(data.data) });
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex h-full w-full overflow-y-auto">
      <Menubar />
      <div className="h-screen w-full overflow-y-auto">
        <Navbar />
        <div>
          <div className={"ml-4 mt-10 flex gap-2 sm:ml-10 sm:mt-14"}>
            <h1 className="font-poppins text-xl font-bold text-black sm:text-2xl">
              {t("Conversion")}
            </h1>
            <Spin spinning={loading} />
          </div>
          <div className="mt-10 w-full border-[1px] border-[#E8E8E8] sm:mt-14" />

          <div className={"mt-10 flex justify-center"}>
            <Form
              initialValues={{ type: 1 }}
              form={form}
              layout={"vertical"}
              className={"w-full md:w-[700px]"}
              onFinish={handleSubmit}
            >
              <Row gutter={{ sm: 10 }}>
                <Col span={12}>
                  <Form.Item name={"type"} label={t("Konvertatsiya turi")}>
                    <Select
                      options={[
                        { label: "usd to uzs", value: 1 },
                        { label: "uzs to usd", value: 2 },
                      ]}
                      onChange={handleChangeConversion}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item name={"date"} label={t("date")}>
                    <DatePicker
                      className={"w-full"}
                      format="DD.MM.YYYY"
                      onChange={getCurrencyRate}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item
                name={"docRate"}
                label={t("Dollar kursi")}
                rules={[
                  {
                    required: true,
                    message: t("required"),
                  },

                  {
                    validator: (_, value) => {
                      // if (
                      //   !value ||
                      //   (value >= docRateApi - 50 && value <= docRateApi + 50)
                      // ) {
                      //   return Promise.resolve();
                      // }
                      // return Promise.reject(
                      //   new Error(
                      //     t("range_error", {
                      //       min: docRateApi - 50,
                      //       max: docRateApi + 50,
                      //     }),
                      //   ),
                      // );
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  value={docRate}
                  onChange={(e) => setDocRate(e.target.value)}
                  className="h-12"
                />
              </Form.Item>
              <Row gutter={{ sm: 10 }}>
                <Col span={12}>
                  <Form.Item name={"input"} label={inputType}>
                    <Input
                      onChange={(e) => handleInputChangeMoney(e, form, "input")}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item name={"output"} label={outputType}>
                    <Input
                      onChange={(e) =>
                        handleInputChangeMoney(e, form, "output")
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
              <div className={"flex justify-end gap-2"}>
                <Button onClick={handleCalculate}>{t("Hisoblash")}</Button>
                <Button
                  type={"primary"}
                  htmlType={"submit"}
                  loading={submitLoading}
                  // disabled={
                  //   // !(docRate >= docRateApi - 50 && docRate <= docRateApi + 50)
                  // }
                >
                  {t("save")}
                </Button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConversionPage;
